import Checkbox from "@mui/material/Checkbox";
import SbuxStyledTableRow from "../../../../../components/SbuxTable/SbuxStyledTableRow";
import SbuxStyledTableCell from "../../../../../components/SbuxTable/SbuxStyledTableCell";
import styles from "../../styles";
import { columns } from "./columns";
import { COLUMN_ID_SNO } from "../../../../../constants/index";
import { dateWithFormat } from "../../../../../utils/dateUtil";
import useCss from "../../../../../hooks/useCss";
import { calcRowClassName, isInvalidRow, StopContactRow } from "./util";
import React from "react";

interface Props {
  row: StopContactRow;
  handleEditRowClick: (row: StopContactRow) => void;
}

export const EditStopContactsRow = ({ row, handleEditRowClick }: Props) => {
  const classes = useCss(styles);

  const handleCheckboxChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    record: StopContactRow,
  ) => {
    handleEditRowClick({ ...record, isChecked: event.target.checked });
  };

  return (
    <SbuxStyledTableRow
      className={calcRowClassName(row, classes.invalid)}
      sx={{ "& > *": { borderBottom: "unset" } }}
    >
      {columns.map((column) => {
        if (column.id === COLUMN_ID_SNO) {
          return (
            <SbuxStyledTableCell
              key={column.id}
              sx={{ padding: "6px 0px 6px 6px !important" }}
            >
              <Checkbox
                inputProps={{ "aria-label": "controlled" }}
                disableFocusRipple
                disableRipple
                checked={Boolean(row?.isChecked)}
                onChange={(e) => {
                  handleCheckboxChange(e, row);
                }}
                className={classes.cellCheckbox}
                disabled={isInvalidRow(row)}
              />
            </SbuxStyledTableCell>
          );
        } else {
          return (
            <SbuxStyledTableCell
              key={column.id}
              className={classes.stopContactCell}
            >
              {column.id === "initiationTimestamp"
                ? dateWithFormat(row[column.id] as string, "YYYY-MM-DD hh:mm A")
                : String(row[column.id] ?? "")}
            </SbuxStyledTableCell>
          );
        }
      })}
    </SbuxStyledTableRow>
  );
};
